<div class="video d-flex flex-fill align-items-center" [ngClass]="styleClasses" [appCssBackgroundImageProxy]="_box.PictureUrl" [ngStyle]="customStyle">
  <div [ngStyle]="getBannerBackGround()">
    <ng-container *ngIf="_box.Title && _box.ShowTitle"  class="video-infobox-ng-container">
      <h4 *ngIf="!isAreaHero" class="infobox-title font-weight-bold">
        {{_box.Title}}
      </h4>
      <!--If info box is top hero make header a lot bigger-->
      <h2 *ngIf="isAreaHero" class="infobox-title font-weight-bold">
        {{_box.Title}}
      </h2>
    </ng-container>
    <i role="img" alt="Play video" class="fa-4x fa fa-play-circle-o"></i>
  </div>

  <!-- Make whole box clickable -->
  <a class="clickable stretched-link infobox-link" title="{{_box.Title}}" (click)="openVideoDialog($event)" *ngIf="_box.VideoEmbedCode" href="#Play">
    <span class="sr-only">{{_box.Title}}</span>
  </a>

</div>

<!-- Embedded Video -->
<ng-template #videoTmpl>
  <div (keypress)="closeVideo()" (click)="closeVideo()" class="playing-video-container">
    <button mat-icon-button color="primary" i18n-aria-label="@@close-video" aria-label="Close video"
      (click)="closeVideo()">
      <mat-icon role="img" alt="Close" class="icon-color">close</mat-icon>
    </button>
    <div [innerHTML]="_box.VideoEmbedCode | safe:'html'"></div>
  </div>
</ng-template>
